import * as Sentry from '@sentry/react';

export const logError = (error: unknown) => {
  console.error(error);
  Sentry.captureException(error);
};
